export const COMPONENT_NAME = 'BannerWithEventFilterSubLayout';
export const FILTER_SECTION = 'filter_section';
export const SMARTLIST_SECTION = 'smart_list_section';
export const FILTEREEDLIST_SECTION = 'filtered_list_section';
